import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserAccountContainer } from '@components/organisms/UserAccountContainer';
import { SpaceForm } from '@components/molecules/SpaceForm';

export const AdminSpacesEdit: FC = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const { t } = useTranslation();

    return (
        <UserAccountContainer title={t('user-account-sidebar.edit-space')}>
            <div className="mt-3">
                <SpaceForm edit={true} spaceUuid={uuid} />
            </div>
        </UserAccountContainer>
    );
};
